import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const usePublishTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (templateId: string) => {
      await request({
        path: `template/publish`,
        method: 'POST',
        authenticate: true,
        dataObject: { _id: templateId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-templates'] });
      toast.success('Template published successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error publishing template!');
    },
  });
};
